import { render, staticRenderFns } from "./input-quick-table.vue?vue&type=template&id=ab99bbe2&scoped=true"
import script from "./input-quick-table.ts?vue&type=script&lang=js&external"
export * from "./input-quick-table.ts?vue&type=script&lang=js&external"
import style0 from "./input-quick-table.vue?vue&type=style&index=0&id=ab99bbe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab99bbe2",
  null
  
)

export default component.exports